import { Modal } from "react-bootstrap";
import { SW_LOGO } from "../../../../../../actions/api";
import { getInitialRoute } from "../../../../../../utils";
import moment from "moment";

const InvoiceModal = ({ userData, showInvoice, invoiceInfo, closeInvoicePopup, downloadInvoicePDF, downloadLoading }) => {
  const invoiceView = invoiceInfo?.invoiceView;
  const showRenewalData = invoiceView ? getInitialRoute() != 'widget' ? userData.UserPlan.planId.split(',').reduce((acc, curr) => {
    if (["54", "55", "61"].includes(curr)) acc = false;
    return acc;
  }, true) : true : true;
  const logoInvoice = SW_LOGO;

  return (
    <Modal size="lg" show={showInvoice} onHide={closeInvoicePopup} centered >
      <Modal.Header closeButton>
        <Modal.Title>Invoice</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {invoiceView ? (
          <div id="invoice_page" className="invoice_page">
            <div className="mb-10 p-0 p-lg-5">
              <div className="flex-column d-flex justify-content-center py-5">
                <div className="d-flex justify-content-between flex-wrap">
                  <a className="mb-10 pe-8 me-8 d-flex flex-grow-1"> <img className="img-fluid" src={logoInvoice} alt="tagbox" height={46} width={200} /> </a>
                  <div className="d-flex flex-column align-items-md-end px-0">
                    <h5>INVOICE</h5>
                    <span className=" d-flex flex-column align-items-md-end opacity-70">
                      <span className="font-weight-bolder text-dark">
                        Invoice : #{invoiceView?.invoiceId}
                      </span>
                      {invoiceView?.gstinCompany ? (<span className="font-weight-bolder text-dark"> GSTIN : {invoiceView?.gstinCompany} </span>) : ("")}
                    </span>
                  </div>
                </div>
                <div className="border-bottom w-100"></div>
                <div className="d-flex justify-content-between pt-6 flex-wrap">
                  <div className="d-flex flex-column flex-root mb-2">
                    <span className="font-weight-bolder mb-2">DATE</span>
                    <span className="opacity-70">
                      {moment(invoiceView?.invoiceDate).format("DD MMM YYYY")}
                    </span>
                  </div>
                  {invoiceView?.gstin ? (
                    <div className="d-flex flex-column flex-root mb-2">
                      <span className="font-weight-bolder mb-2">GSTIN.</span>
                      <span className="opacity-70">#{invoiceView?.gstin}</span>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="d-flex flex-column flex-root mb-2">
                      {invoiceView?.invoiceDueDate != "" ? <>
                        <span className="font-weight-bolder mb-2">{showRenewalData ? `NEXT RENEWAL DATE` : `INVOICE NO.`}</span>
                        <span className="opacity-70">{showRenewalData ? moment(invoiceView?.invoiceDueDate).format("DD MMM YYYY") : `#${invoiceView?.invoiceId}`}</span>
                      </> : null}

                  </div>
                  <div className="d-flex flex-column flex-root mb-2">
                    <span className="font-weight-bolder mb-2">INVOICE TO.</span>
                    <span className="opacity-70">
                      {invoiceView?.customerName}
                      <br />
                      {invoiceView?.address1Value}
                      <br />
                      {invoiceView?.address2Value} <br />
                      {invoiceView?.countryvalue}
                      <br />
                    </span>
                  </div>
                </div>
                <div className="justify-content-center py-8 py-md-10">
                  <div className="table-responsive border-top">
                    <table className="table m-0">
                      <thead>
                        <tr>
                          <th className="ps-0 font-weight-bold text-muted  text-uppercase"> Description </th>
                          <th className="text-right pe-0 font-weight-bold text-muted text-uppercase"> Amount </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="font-weight-boldest">
                          <td className="ps-0 align-top font-weight-boldest"> {invoiceView?.item} </td>
                          <td width="30%" className="border-left p-0 text-right" >
                            <table className="table m-0 ">
                              <tbody>

                                <tr className="font-weight-boldest">
                                  <td className="pe-0  text-right border-top-0">

                                    {invoiceView?.currencyValue}
                                    {invoiceView?.amount}
                                  </td>
                                </tr>


                                {invoiceView.discountPercent > 0 ? <><tr className="font-weight-boldest">
                                  <td className="pe-0  text-right"> Discount ({invoiceView?.discountPercent + "%"}) :  {invoiceView?.discountAmount} </td>
                                </tr></> : ''}

                                {invoiceView.vat > 0 ? (
                                  <tr className="font-weight-boldest">
                                    <td className="pe-0  text-right"> GST(18%) : {invoiceView?.currencyValue} {invoiceView?.vat} </td>
                                  </tr>
                                ) : (
                                  ""
                                )}
                                <tr className="font-weight-boldest">
                                  <td className="pe-0  text-right"> Total :{invoiceView?.currencyValue} {invoiceView?.total} </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="justify-content-center border-top pt-3">
                    <div className="d-flex justify-content-between flex-wrap">
                      <span className="my-3 font-weight-bold"> Social Scape Tech LLP, C-2 Panchsheel Colony, JPR, RJ (IN) </span>
                      <button className={`btn btn-primary m-0 font-weight-bold ${downloadLoading == 2 ? `spinner spinner-white spinner-right disabled` : ''}`} onClick={downloadInvoicePDF(invoiceInfo?.invoiceId, invoiceView?.invoiceId, 1)} > Download Invoice </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </Modal.Body>
    </Modal>
  );
};

export default InvoiceModal;
